import React, { useEffect, useRef, useState } from 'react';
import { Grid, Button } from '@material-ui/core';
import { ModalWrapper } from 'components/Modals';
import TokenIcon from 'assets/images/token.svg';
import { shuffle } from 'helpers';
import { motion } from 'framer-motion';
import './CreditsModal.scss';
import { useDispatch, useSelector } from 'react-redux';
import { deleteTours } from 'redux/thunks';
import { RootStore } from 'redux/store';
import { LoaderButton } from 'components/LoaderButton';
import { useEasterEggFound } from 'helpers/easterEgghelper';
import EASTER_EGG_IDS from 'helpers/easterEggConstants';

interface CreditsModalProps {
	open: boolean;
	onCloseClicked: () => void;
	allowClickOutsideToClose?: boolean;
}

const CreditsModal: React.FC<CreditsModalProps> = (props: CreditsModalProps) => {
	const { open, allowClickOutsideToClose, onCloseClicked } = props;
	// As you make changes to this application feel free to add your name to the list of developers or designers
	// Please refrain from removing names from this list (even if the individual is no longer around)
	let devTeam = useRef(['Will Jayroe', 'Robby Lagen', 'Weston Kunz', 'Drew Kerby', 'Ewa Oszajec', 'Chris Peca']);
	let designTeam = useRef(['Erika Sibal', 'Joel Garfield']);
	const [devTeamShuffled, setDevTeamShuffuled] = useState<string[]>(devTeam.current);
	const [designTeamShuffled, setDesignTeamShuffuled] = useState<string[]>(designTeam.current);
	const constraintsRef = useRef(null);
	const easterEggFound = useEasterEggFound(EASTER_EGG_IDS.AIR_HOCKEY_COIN);
	const dispatch = useDispatch();
	const deletingTours = useSelector((state: RootStore) => state.user.deletingTours);

	const resetTours = () => {
		dispatch(deleteTours());
	};

	useEffect(() => {
		if (open) {
			setDevTeamShuffuled(shuffle(devTeam.current));
			setDesignTeamShuffuled(shuffle(designTeam.current));
		}
	}, [open]);

	return (
		<ModalWrapper open={open} onCloseClicked={onCloseClicked} allowClickOutsideToClose={allowClickOutsideToClose} constraintsRef={constraintsRef}>
			<Grid container direction='column' alignItems='center' className='credits-grid-container'>
				<span className='eggster' id='eggster' role='img' aria-label='egg'>
					🥚
				</span>
				<motion.img
					onDragEnd={() => easterEggFound()}
					drag
					dragConstraints={constraintsRef}
					src={TokenIcon}
					className='token-icon'
					alt='toa-token'
					title='drag the coin.'
				/>
				<div className='toa-title'>Tokens of Appreciation</div>
				<div className='toa-small-title'>Brought to you by</div>
				<div>MADDUX x Digital Manufacturing</div>
				<div className='toa-small-title'>Product Owner</div>
				<div>Vinh Hoang</div>
				<div className='toa-small-title'>Development</div>
				{devTeamShuffled.map((devMember, index) => {
					return <div key={index}>{devMember}</div>;
				})}
				<div className='toa-small-title'>Design</div>
				{designTeamShuffled.map((designMember, index) => {
					return <div key={index}>{designMember}</div>;
				})}
				<Grid direction='row' container justify='space-between' className='credits-footer'>
					<LoaderButton style={{ marginLeft: 0 }} type='button' variant='contained' color='none' onHandleClick={resetTours} loading={deletingTours}>
						Reset Tours
					</LoaderButton>
					<Button variant='contained' color='primary' onClick={onCloseClicked}>
						back
					</Button>
				</Grid>
			</Grid>
		</ModalWrapper>
	);
};

export default CreditsModal;
